import React, { Fragment, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { H3 } from "../../AbstractElements";
import { X } from "react-feather";
import UserForm from "../../Common/Component/UserForm";

const AddAsmUser = (props) => {
    const [open, setOpen] = useState(props.value);
    

    const onClose = () => {
        setOpen(false);
        props.setOpenModal(false)
    }

    const onSubmit = () => {
        onClose();
    }

    return (
        <Fragment>
            <Modal centered={true} isOpen={open} size='lg'>
                <ModalHeader style={{display: 'flex'}}>
                    <H3>New Proponent Onboarding <X style={{marginLeft: '30rem', color: 'black'}} onClick={onClose}/></H3>
                </ModalHeader>
                <ModalBody>
                <UserForm action={'Add'} onSubmit={onSubmit} cancel={onClose} navigateUrl={`${process.env.PUBLIC_URL}/asm-admin/user-list`}/>
                </ModalBody>
            </Modal>
        </Fragment>
    )
}

export default AddAsmUser;